import { render, staticRenderFns } from "./RoundIconButton.vue?vue&type=template&id=63460306&scoped=true&"
import script from "./RoundIconButton.vue?vue&type=script&lang=js&"
export * from "./RoundIconButton.vue?vue&type=script&lang=js&"
import style0 from "./RoundIconButton.vue?vue&type=style&index=0&id=63460306&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63460306",
  null
  
)

export default component.exports